<!--
 * @Date: 2021-7-21 10:27:45
 * @Author: WZ
 * @Description: 创建订单
 * @remark: 快件类型（expressType）已修改；派送类型已修改；区号（寄件/收件）请求示例还没写上；收寄件手机号码长度去限制？；批次号（batchNumber）、运单编号（billCode）前端去掉；
-->
<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{$t('apiDoc.在线文档')}}</span>
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >{{$t('apiDoc.测试工具')}}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'order/addOrder';
export default {
  components: { onlineDoc , apiTestDoc },
  data() {
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: `${this.$t('onlineDoc.OrderDescription_1')}`,
      //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
         //参数描述  START
       postDataList:[

        //   请求头参数
            {
                title:`${this.$t('onlineDoc.Headers')}`,
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`,},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.签名字符串')}`,},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.时间戳，毫秒')}`,},
                    ]
            },
            {
                title:`${this.$t('onlineDoc.请求参数')}`,
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: `${this.$t('onlineDoc.业务参数')}`,describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`,},
                ]
            },
            {
              title:`${this.$t('onlineDoc.业务参数')}`,
              value:[
                {name: "customerCode",type: "String(30)",require: "Y",normal: "J0086474299",describe:`${this.$t('onlineDoc.客户编码（联系出货网点提供）')}`},
                {name: "digest",type: "String(50)",require: "Y",normal: `${this.$t('onlineDoc.明文密码:H5CD3zE6')}`,describe: `${this.$t('onlineDoc.sign')}`},
                {name: "network",type: "String(30)",require: "N",normal: "",describe: `${this.$t('onlineDoc.合作网点')}`},
                {name: "txlogisticId",type: "String(50)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.客户订单号')}`},
                {name: "expressType",type: "String(30)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.ExpressType1')}`},
                {name: "orderType",type: "String(11)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.OrderType')}`},
                {name: "serviceType",type: "String(30)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.服务类型create')}`},
                {name: "deliveryType",type: "String(30)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.派送类型')}`},
                {name: "payType",type: "String(30)",require: "N",normal: "",describe: `${this.$t('onlineDoc.paymentMethod')}`},
                {name: "sender",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.寄件信息对象')}`},
                {name: "receiver",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.收件信息对象')}`},
                {name: "translate",type: "Object",require: "N",normal: "",describe: `${this.$t('onlineDoc.取件信息对象')}`},
                {name: "sendStartTime",type: "String(30)",require: "N",normal: "",describe: `${this.$t('onlineDoc.LC_pick_up_start_time')}`},
                {name: "sendEndTime",type: "String(30)",require: "N",normal: "",describe: `${this.$t('onlineDoc.CLC_door_to_door_end_time')}`},
                {name: "goodsType",type: "String(30)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.itemtType')}`},
                {name: "length",type: "int(6)",require: "N",normal: "",describe: `${this.$t('onlineDoc.Length')}`},
                {name: "width",type: "int(6)",require: "N",normal: "",describe: `${this.$t('onlineDoc.Width')}`},
                {name: "height",type: "int(6)",require: "N",normal: "",describe: `${this.$t('onlineDoc.Height')}`},
                {name: "weight",type: "String(12)",require: "Y",normal: "0.02",describe: `${this.$t('onlineDoc.Weight')}`},
                {name: "totalQuantity",type: "int(4)",require: "N",normal: "",describe: `${this.$t('onlineDoc.包裹总票数')}`},
                {name: "itemsValue",type: "String(12)",require: "N",normal: "",describe: `${this.$t('onlineDoc.代收货款金额 (数值型)')}`},
                {name: "priceCurrency",type: "String(32)",require: "N",normal: "",describe: `${this.$t('onlineDoc.collectionPayment')}`},
                {name: "offerFee",type: "String(12)",require: "N",normal: "",describe: `${this.$t('onlineDoc.offerFee')}`},
                {name: "remark",type: "String(200)",require: "N",normal: "",describe: `${this.$t('onlineDoc.备注')}`},
                {name: "items",type: "Object",require: "N",normal: "",describe: `${this.$t('onlineDoc.商品信息列表')}`},
                {name: "orderInformation",type: "List<Object>",require: "N",normal: "",describe: `${this.$t('onlineDoc.子订单信息')}`},
                {name: "invoiceNumber",type: "String(44)",require: "N",normal: "",describe: `${this.$t('onlineDoc.invoceNumberNew')}`},
                {name: "invoiceSerialNumber",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.invoiceSerialNumber')}`},
                {name: "invoiceMoney",type: "String(12)",require: "N",normal: "",describe: `${this.$t('onlineDoc.invoicemoney')}`},
                {name: "taxCode",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.taxCode')}`},
                {name: "invoiceAccessKey",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.invoiceAccessKey')}`},
                {name: "invoiceIssueDate",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.invoiceIssueDate')}`},
                {name: "packingNumber",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.packingNumber')}`},
                {name: "documentNumber",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.documentNumber')}`},
                {name: "documentSeries",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.documentSeries')}`},
                {name: "documentKey",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.documentKey')}`},
                {name: "documentCteKey",type: "String(44)",require: "N",normal: "",describe: `${this.$t('onlineDoc.documentCteKey')}`},
                {name: "cteKey",type: "String(50)",require: "N",normal: "",describe: `${this.$t('onlineDoc.cteKey')}`},
                {name: "invoiceType",type: "String(10)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.invoiceType')}`},
                {name: "docType",type: "int",require: "N",normal: "",describe: `${this.$t('onlineDoc.docType')}`}
              ]
            },
            {
              title:`${this.$t('onlineDoc.orderInformation类型说明(数组)')}`,
              value:[
                {name: "txlogisticId",type: "String(50)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.客户订单号（传客户自己系统的订单号）')}`},
                {name: "sender",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.寄件信息对象')}`},
                {name: "receiver",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.收件信息对象')}`},
                {name: "goodsType",type: "String(30)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.itemtType')}`},
                {name: "length",type: "int(6)",require: "N",normal: "",describe: `${this.$t('onlineDoc.Length')}`},
                {name: "width",type: "int(6)",require: "N",normal: "",describe: `${this.$t('onlineDoc.Width')}`},
                {name: "height",type: "int(6)",require: "N",normal: "",describe: `${this.$t('onlineDoc.Height')}`},
                {name: "weight",type: "String(12)",require: "Y",normal: "0.02",describe: `${this.$t('onlineDoc.Weight')}`},
                {name: "totalQuantity",type: "int(4)",require: "N",normal: "",describe: `${this.$t('onlineDoc.包裹总票数')}`},
                {name: "itemsValue",type: "String(12)",require: "N",normal: "",describe: `${this.$t('onlineDoc.代收货款金额 (数值型)')}`},
                {name: "priceCurrency",type: "String(32)",require: "N",normal: "",describe: `${this.$t('onlineDoc.collectionPayment')}`},
                {name: "remark",type: "String(200)",require: "N",normal: "",describe: `${this.$t('onlineDoc.备注')}`},
                {name: "items",type: "Object",require: "N",normal: "",describe: `${this.$t('onlineDoc.商品信息列表')}`},
                {name: "invoiceNumber",type: "String(44)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.发票号码')}`},
                {name: "invoiceSerialNumber",type: "String(100)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.发票序列号')}`},
                {name: "invoiceMoney",type: "String(12)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.发票金额(数值型)，单位：BRL')}`},
                {name: "taxCode",type: "String(100)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.发票税号')}`},
                {name: "invoiceAccessKey",type: "String(100)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.发票密钥')}`},
                {name: "invoiceIssueDate",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.invoiceIssueDate')}`},
                {name: "packingNumber",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.packingNumber')}`},
                {name: "documentNumber",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.documentNumber')}`},
                {name: "documentSeries",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.documentSeries')}`},
                {name: "documentKey",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.documentKey')}`},
                {name: "documentCteKey",type: "String(44)",require: "N",normal: "",describe: `${this.$t('onlineDoc.documentCteKey')}`},
                {name: "cteKey",type: "String(50)",require: "N",normal: "",describe: `${this.$t('onlineDoc.cteKey')}`},
                {name: "invoiceType",type: "String(10)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.invoiceType')}`},
                {name: "docType",type: "int",require: "N",normal: "",describe: `${this.$t('onlineDoc.docType')}`}
              ]
            },
            {
              title:`${this.$t('onlineDoc.sender类型说明')}`,
              value:[
                {name: "name",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.寄件人姓名')}`},
                {name: "company",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.寄件公司')}`},
                {name: "postCode",type: "String(8)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.寄件邮编（固定8位长度）')}`},
                {name: "mailBox",type: "String(150)",require: "N",normal: "",describe: `${this.$t('onlineDoc.寄件邮箱')}`},
                {name: "taxNumber",type: "String(100)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.taxNumberNew')}`},
                {name: "mobile",type: "String(30)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.SendingMobilePhone')}`},
                {name: "phone",type: "String(30)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.SendingPhoneNumber')}`},
                {name: "prov",type: "String(100)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.寄件州')}`},
                {name: "city",type: "String(100)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.寄件市')}`},
                {name: "area",type: "String(100)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.寄件区')}`},
                {name: "street",type: "String(100)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.寄件街道')}`},
                {name: "streetNumber",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.寄件街道号')}`},
                {name: "address",type: "String(300)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.寄件详细地址')}`},
                {name: "areaCode",type: "String(32)",require: "N",normal: "",describe: `${this.$t('onlineDoc.寄件区号')}`},
                {name: "ieNumber",type: "String(100)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.寄件人IE号')}`},
                {name: "longitude",type: "String(10)",require: "N",normal: "",describe: `${this.$t('onlineDoc.经度New')}`},
                {name: "latitude",type: "String(10)",require: "N",normal: "",describe: `${this.$t('onlineDoc.纬度New')}`}
              ]
            },
            {
              title:`${this.$t('onlineDoc.receiver类型说明')}`,
              value:[
                {name: "name",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.收件人姓名')}`},
                {name: "company",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.收件公司')}`},
                {name: "postCode",type: "String(8)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.收件邮编（固定8位长度）')}`},
                {name: "mailBox",type: "String(150)",require: "N",normal: "",describe: `${this.$t('onlineDoc.收件邮箱')}`},
                {name: "taxNumber",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.taxNumber2')}`},
                {name: "mobile",type: "String(30)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.ReceivingMobilephone')}`},
                {name: "phone",type: "String(30)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.ReceivingPhoneNumber')}`},
                {name: "prov",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.收件州')}`},
                {name: "city",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.收件市')}`},
                {name: "area",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.收件区')}`},
                {name: "street",type: "String(100)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.收件街道')}`},
                {name: "streetNumber",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.收件街道号')}`},
                {name: "address",type: "String(150)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.收件详细地址')}`},
                {name: "areaCode",type: "String(32)",require: "N",normal: "",describe: `${this.$t('onlineDoc.收件区号')}`},
                {name: "ieNumber",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.收件人IE号')}`},
                {name: "longitude",type: "String(10)",require: "N",normal: "",describe: `${this.$t('onlineDoc.经度New')}`},
                {name: "latitude",type: "String(10)",require: "N",normal: "",describe: `${this.$t('onlineDoc.纬度New')}`}
              ]
            },
            {
              title:`${this.$t('onlineDoc.translate类型说明')}`,
              value:[
                {name: "name",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.取件人姓名')}`},
                {name: "company",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.取件公司')}`},
                {name: "postCode",type: "String(8)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.取件邮编')}`},
                {name: "mailBox",type: "String(150)",require: "N",normal: "",describe: `${this.$t('onlineDoc.取件邮箱')}`},
                {name: "taxNumber",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.个人税号（限制14位字符）')}`},
                {name: "mobile",type: "String(30)",require: "N",normal: "",describe: `${this.$t('onlineDoc.取件人手机（手机和电话二选一必填）')}`},
                {name: "phone",type: "String(30)",require: "N",normal: "",describe: `${this.$t('onlineDoc.取件人电话（手机和电话二选一必填）')}`},
                {name: "prov",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.取件州')}`},
                {name: "city",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.取件市')}`},
                {name: "area",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.取件区')}`},
                {name: "street",type: "String(100)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.取件街道')}`},
                {name: "streetNumber",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.取件街道号')}`},
                {name: "address",type: "String(150)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.取件详细地址')}`},
                {name: "areaCode",type: "String(32)",require: "N",normal: "",describe: `${this.$t('onlineDoc.取件区号')}`},
                {name: "ieNumber",type: "String(100)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.取件人IE号')}`},
                {name: "longitude",type: "String(10)",require: "N",normal: "",describe: `${this.$t('onlineDoc.经度New')}`},
                {name: "latitude",type: "String(10)",require: "N",normal: "",describe: `${this.$t('onlineDoc.纬度New')}`}
              ]
            },
            {
              title:`${this.$t('onlineDoc.items类型说明')}`,
              value:[
                {name: "itemType",type: "String(30)",require: "N",normal: "",describe: `${this.$t('onlineDoc.物品类型')}`},
                {name: "itemNcm",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.商品NCM')}`},
                {name: "itemNcmDesc",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.NCM描述')}`},
                {name: "itemName",type: "String(30)",require: "N",normal: "",describe: `${this.$t('onlineDoc.物品名称')}`},
                {name: "chineseName",type: "String(60)",require: "N",normal: "",describe: `${this.$t('onlineDoc.物品中文名称')}`},
                {name: "englishName",type: "String(60)",require: "N",normal: "",describe: `${this.$t('onlineDoc.物品英文名称')}`},
                {name: "number",type: "int(4)",require: "N",normal: "",describe: `${this.$t('onlineDoc.cases')}`},
                {name: "itemValue",type: "String(20)",require: "N",normal: "",describe: `${this.$t('onlineDoc.申报价值(数值型)')}`},
                {name: "priceCurrency",type: "String(20)",require: "N",normal: "",describe: `${this.$t('onlineDoc.priceCurrency')}`},
                {name: "desc",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.物品描述')}`},
                {name: "itemUrl",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.商品URL')}`}
              ]
            }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[

        //   响应参数
            {
                title:`${this.$t('onlineDoc.响应参数')}`,
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回码，见附录')}`},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.描述')}`},
                    {name: "data",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.业务数据')}`},
                  ]
            },
            {
              title:`${this.$t('onlineDoc.data类型说明')}`,
              value:[
                  {name: "lastCenterName",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.集包地')}`},
                  {name: "createOrderTime",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.订单创建时间')}`},
                  {name: "sortingCode",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.三段码online')}`},
                  {name: "orderList",type: "List<Object>",require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回订单信息')}`},
                ]
            },
            {
              title:`${this.$t('onlineDoc.orderList类型说明（数组）')}`,
              value:[
                  {name: "txlogisticId",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回客户订单号')}`},
                  {name: "billCode",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.运单号')}`},
                ]
            }

        ],
        //请求示例
        requestCode: `Header：
apiAccount=1627
digest=U40e5sumorgd3YgZzU61Mw==
timestamp=1565238848921

Body：
bizContent={
"customerCode": "J0086474299",
"digest": "U40e5sumorgd3YgZzU",
"network": "null",
"txlogisticId": "12312312312",
"expressType": "standard",
"orderType": 1,
"serviceType": "01",
"deliveryType": "03",
"payType": "PP_PM",
"sender": {
"name": "Lonnnie",
"company": "company details",
"postCode": "06524115",
"mailBox": "ant_li@qq.com",
"taxNumber": "111231231",
"mobile": "12345678909",
"phone": "12345678909",
"prov": "SP",
"city": "Santana de Parnaíba",
"street": "Cururuquara",
"streetNumber": "231",
"address": "detailed address",
"areaCode": "122222",
"ieNumber": "456774332",
"area": "Pickup area"
"longitude": "21.123456"
"latitude": "21.123456"
},
"receiver": {
"name": "Lonnnie",
"company": "company details",
"postCode": "06524115",
"mailBox": "ant_li@qq.com",
"taxNumber": "111231231",
"mobile": "12345678909",
"phone": "12345678909",
"prov": "SP",
"city": "Santana de Parnaíba",
"street": "Cururuquara",
"streetNumber": "231",
"address": "detailed address",
"areaCode": "122222",
"ieNumber": "456774332",
"area": "Pickup area"
"longitude": "21.123456"
"latitude": "21.123456"
},
"sendStartTime": "2022-08-30 8:28:00",
"sendEndTime": "2022-08-31 16:28:00",
"goodsType": "bm000001",
"length": 50,
"width": 50,
"height": 1,
"weight": 1,
"totalQuantity": 1,
"itemsValue": "200",
"priceCurrency": "DHS",
"offerFee": "200000",
"remark": "Important documents",
"items": [
{
"itemType": "bm000001",
"itemName": "file",
"chineseName": "fileC",
"englishName": "fileE",
"number": "1",
"itemValue": "200000",
"priceCurrency": "DHS",
"desc": "file",
"itemUrl": "",
"itemNcm":"itemNcm"
}
],
"translate": {
"name": "Lonnnie",
"company": "company details",
"postCode": "06524115",
"mailBox": "ant_li@qq.com",
"taxNumber": "111231231",
"mobile": "12345678909",
"phone": "12345678909",
"prov": "SP",
"city": "Santana de Parnaíba",
"street": "Cururuquara",
"streetNumber": "231",
"address": "detailed address",
"areaCode": "122222",
"ieNumber": "456774332",
"area": "Pickup area"
"longitude": "21.123456"
"latitude": "21.123456"
},
"invoiceNumber": "2332323",
"invoiceSerialNumber": "32323",
"invoiceMoney": "200",
"taxCode": "2342424",
"invoiceAccessKey": "12312323",
"invoiceIssueDate": "2022-08-31 16:28:00",
"packingNumber": "2312313",
"documentNumber": "123123131",
"documentSeries": "123123131",
"documentKey": "345456234234",
"documentCteKey": "345456234234",
"orderInformation": [
{
"txlogisticId": "10000000001299",
"sender": {
"name": "Lonnnie",
"company": "company details",
"postCode": "06524115",
"mailBox": "ant_li@qq.com",
"taxNumber": "111231231",
"mobile": "12345678909",
"phone": "12345678909",
"prov": "SP",
"city": "Santana de Parnaíba",
"street": "Cururuquara",
"streetNumber": "231",
"address": "detailed address",
"areaCode": "122222",
"ieNumber": "456774332",
"area": "Pickup area"
"longitude": "21.123456"
"latitude": "21.123456"
},
"receiver": {
"name": "Lonnnie",
"company": "company details",
"postCode": "06524115",
"mailBox": "ant_li@qq.com",
"taxNumber": "111231231",
"mobile": "12345678909",
"phone": "12345678909",
"prov": "SP",
"city": "Santana de Parnaíba",
"street": "Cururuquara",
"streetNumber": "231",
"address": "detailed address",
"areaCode": "122222",
"ieNumber": "456774332",
"area": "Pickup area"
"longitude": "21.123456"
"latitude": "21.123456"
},
"goodsType": "bm000001",
"length": 50,
"width": 50,
"height": 1,
"weight": 1,
"totalQuantity": 1,
"itemsValue": "200",
"priceCurrency": "DHS",
"remark": "Important documents",
"items": [
{
"itemType": "bm000001",
"itemName": "file",
"chineseName": "fileC",
"englishName": "fileE",
"number": "1",
"itemValue": "200000",
"priceCurrency": "DHS",
"desc": "file",
"itemUrl": "",
"itemNcm":"itemNcm"
}
],
"invoiceNumber": "2332323",
"invoiceSerialNumber": "32323",
"invoiceMoney": "200",
"taxCode": "2342424",
"invoiceAccessKey": "12312323",
"invoiceIssueDate": "2022-08-31 16:28:00",
"packingNumber": "2312313",
"documentNumber": "123123131",
"documentSeries": "123123131",
"documentKey": "345456234234",
"documentCteKey": "345456234234"
}
]
}`,
        //返回示例
        responseCode: JSON.parse(
          `{
    "code": "1",
    "msg": "success",
    "data": {
        "lastCenterName": "transshipment center",
        "sortingCode": "551 200-00 029",
        "createOrderTime": "2021-02-18 11:50:57",
        "sumFreight": "100",
        "orderList": [
            {
                "txlogisticId": "211120202012031",
                "billCode": "211120202012031"
            },
            {
                "txlogisticId": "211120202012031",
                "billCode": "211120202012031"
            },
            {
                "txlogisticId": "211120202012031",
                "billCode": "211120202012031"
            }
        ]
    }
}`
        ),


        //错误代码提示
        errcodeJson: [
          {code:'145003031',msg:`${this.$t('apiTestDoc.业务参数签名失败')}`},
        {code:'145003060',msg:`${this.$t('apiTestDoc.区域不合法')}`},
        {code:'145003061',msg:`${this.$t('apiTestDoc.城市不合法')}`},
        {code:'145003062',msg:`${this.$t('apiTestDoc.省份不合法')}`},
        {code:'145003064',msg:`${this.$t('apiTestDoc.查不到数据')}`},
        {code:'145003041',msg:`${this.$t('apiTestDoc.下单失败')}`},
        {code:'145003083',msg:`${this.$t('apiTestDoc.发件人信息不全')}`},
        {code:'145003084',msg:`${this.$t('apiTestDoc.收件人信息不全')}`},
        {code:'145003085',msg:`${this.$t('apiTestDoc.电话号码不能为空')}`},
        {code:'145003086',msg:`${this.$t('apiTestDoc.地址信息不全')}`},
        {code:'145003087',msg:`${this.$t('apiTestDoc.请检查订单类型、服务类型、派送类型、物品类型、快件类型、结算方式是否合法')}`},
        {code:'145003200',msg:`${this.$t('apiTestDoc.请检查服务类型是否合法值为 01或 02')}`},
        {code:'145003092',msg:`${this.$t('apiTestDoc.重量信息不合法')}`},
        {code:'145003093',msg:`${this.$t('apiTestDoc.物品信息不全')}`},
        {code:'145003094',msg:`${this.$t('apiTestDoc.物品名称不全')}`},
        {code:'145003095',msg:`${this.$t('apiTestDoc.物品类型不全')}`},
        {code:'145003101',msg:`${this.$t('apiTestDoc.客户订单号已存在,无法下单！')}`},
        {code:'145003103',msg:`${this.$t('apiTestDoc.姓名信息非法')}`},
        {code:'145003104',msg:`${this.$t('apiTestDoc.公司信息过长')}`},
        {code:'145003105',msg:`${this.$t('apiTestDoc.联系信息过长')}`},
        {code:'145003106',msg:`${this.$t('apiTestDoc.邮编或邮箱信息非法')}`},
        {code:'145003107',msg:`${this.$t('apiTestDoc.价格信息非法')}`},
        {code:'145003108',msg:`${this.$t('apiTestDoc.备注、描述、链接信息非法')}`},
        {code:'145003109',msg:`${this.$t('apiTestDoc.地址信息过长')}`},
        {code:'145003110',msg:`${this.$t('apiTestDoc.街道信息过长')}`},
        {code:'145003111',msg:`${this.$t('apiTestDoc.包裹总件数无效')}`},
        {code:'145003112',msg:`${this.$t('apiTestDoc.暂未开通代收货款业务')}`},
        {code:'145003113',msg:`${this.$t('apiTestDoc.支付方式不匹配,PP_CASH,CC_CASH,PP_MM')}`},
        {code:'145003201',msg:`${this.$t('apiTestDoc.已取件状态不可修改')}`},
        {code:'145003202',msg:`${this.$t('apiTestDoc.已取消状态不可修改')}`},
        {code:'145003203',msg:`${this.$t('apiTestDoc.更新订单失败，请稍后重试！')}`},
        {code:'145003083',msg:`${this.$t('apiTestDoc.始发地信息不全')}`},
        {code:'145003084',msg:`${this.$t('apiTestDoc.收货地信息不全')}`},
        {code:'145003085',msg:`${this.$t('apiTestDoc.发票信息不全')}`},
        {code:'145003086',msg:`${this.$t('apiTestDoc.发票信息不合法')}`},
        {code:'145003087',msg:`${this.$t('apiTestDoc.寄件人个人税号信息非法')}`},
        {code:'145003088',msg:`${this.$t('apiTestDoc.订单数量不同，无法修改订单')}`},
        {code:'145003204',msg:`${this.$t('apiTestDoc.客户订单号重复，请稍后重试')}`},
        {code:'145003305',msg:`${this.$t('apiTestDoc.请输入正确的税号')}`},
        {code:'145003306',msg:`${this.$t('apiTestDoc.请输入正确的IE号')}`},
        {code:'145003066',msg:`${this.$t('apiTestDoc.非法发件人邮政编码/非法收件人邮政编码/非法取件人邮政编码')}`},
        {code:'145003080',msg:`${this.$t('apiTestDoc.找不到客户')}`},
        {code:'145003081',msg:`${this.$t('apiTestDoc.客户代码不合法')}`},
        {code:'145003082',msg:`${this.$t('apiTestDoc.客户订单号不能为空或太长')}`},
        {code:'145105003',msg:`${this.$t('apiTestDoc.订单数量不一致')}`},
        {code:'1450033312',msg:`${this.$t('apiTestDoc.请填写正确的快件类型')}`},
        {code:'1450033313',msg:`${this.$t('apiTestDoc.请填写正确的派送类型')}`},
        {code:'1450033315',msg:`${this.$t('apiTestDoc.请填写正确的寄件/收件酋长国和地区')}`},
        {code:'1450033316',msg:`${this.$t('apiTestDoc.操作类型不能为空')}`},
        {code:'1450033317',msg:`${this.$t('apiTestDoc.COD和COD的币种必须为空或同时必填')}`},
        {code:'1450033318',msg:`${this.$t('apiTestDoc.COD(货到付款)不能大于30000')}`}]
      },

      apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `{
    "customerCode": "J0086474299",
    "digest": "U40e5sumorgd3YgZzU",
    "network": "null",
    "txlogisticId": "12312312312",
    "expressType": "standard",
    "orderType": 1,
    "serviceType": "01",
    "deliveryType": "03",
    "payType": "PP_PM",
    "sender": {
        "name": "Lonnnie",
        "company": "company details",
        "postCode": "06524115",
        "mailBox": "ant_li@qq.com",
        "taxNumber": "111231231",
        "mobile": "12345678909",
        "phone": "12345678909",
        "prov": "SP",
        "city": "Santana de Parnaíba",
        "street": "Cururuquara",
        "streetNumber": "231",
        "address": "detailed address",
        "areaCode": "122222",
        "ieNumber": "456774332",
        "area": "Pickup area"
    },
    "receiver": {
        "name": "Lonnnie",
        "company": "company details",
        "postCode": "06524115",
        "mailBox": "ant_li@qq.com",
        "taxNumber": "111231231",
        "mobile": "12345678909",
        "phone": "12345678909",
        "prov": "SP",
        "city": "Santana de Parnaíba",
        "street": "Cururuquara",
        "streetNumber": "231",
        "address": "detailed address",
        "areaCode": "122222",
        "ieNumber": "456774332",
        "area": "Pickup area"
    },
    "sendStartTime": "2022-08-30 8:28:00",
    "sendEndTime": "2022-08-31 16:28:00",
    "goodsType": "bm000001",
    "length": 50,
    "width": 50,
    "height": 1,
    "weight": 1,
    "totalQuantity": 1,
    "itemsValue": "200",
    "priceCurrency": "DHS",
    "offerFee": "200000",
    "remark": "Important documents",
    "items": [
        {
            "itemType": "bm000001",
            "itemName": "file",
            "chineseName": "fileC",
            "englishName": "fileE",
            "number": "1",
            "itemValue": "200000",
            "priceCurrency": "DHS",
            "desc": "file",
            "itemUrl": "",
            "itemNcm":"itemNcm"
        }
    ],
    "translate": {
                "name": "Lonnnie",
                "company": "company details",
                "postCode": "06524115",
                "mailBox": "ant_li@qq.com",
                "taxNumber": "111231231",
                "mobile": "12345678909",
                "phone": "12345678909",
                "prov": "SP",
                "city": "Santana de Parnaíba",
                "street": "Cururuquara",
                "streetNumber": "231",
                "address": "detailed address",
                "areaCode": "122222",
                "ieNumber": "456774332",
                "area": "Pickup area"
    },
    "invoiceNumber": "2332323",
    "invoiceSerialNumber": "32323",
    "invoiceMoney": "200",
    "taxCode": "2342424",
    "invoiceAccessKey": "12312323",
    "invoiceIssueDate": "2022-08-31 16:28:00",
    "packingNumber": "2312313",
    "documentNumber": "123123131",
    "documentSeries": "123123131",
    "documentKey": "345456234234",
    "documentCteKey": "345456234234",
    "orderInformation": [
        {
            "txlogisticId": "10000000001299",
            "sender": {
                "name": "Lonnnie",
                "company": "company details",
                "postCode": "06524115",
                "mailBox": "ant_li@qq.com",
                "taxNumber": "111231231",
                "mobile": "12345678909",
                "phone": "12345678909",
                "prov": "SP",
                "city": "Santana de Parnaíba",
                "street": "Cururuquara",
                "streetNumber": "231",
                "address": "detailed address",
                "areaCode": "122222",
                "ieNumber": "456774332",
                "area": "Pickup area"
            },
            "receiver": {
                "name": "Lonnnie",
                "company": "company details",
                "postCode": "06524115",
                "mailBox": "ant_li@qq.com",
                "taxNumber": "111231231",
                "mobile": "12345678909",
                "phone": "12345678909",
                "prov": "SP",
                "city": "Santana de Parnaíba",
                "street": "Cururuquara",
                "streetNumber": "231",
                "address": "detailed address",
                "areaCode": "122222",
                "ieNumber": "456774332",
                "area": "Pickup area"
            },
            "goodsType": "bm000001",
            "length": 50,
            "width": 50,
            "height": 1,
            "weight": 1,
            "totalQuantity": 1,
            "itemsValue": "200",
            "priceCurrency": "DHS",
            "remark": "Important documents",
            "items": [
                {
                    "itemType": "bm000001",
                    "itemName": "file",
                    "chineseName": "fileC",
                    "englishName": "fileE",
                    "number": "1",
                    "itemValue": "200000",
                    "priceCurrency": "DHS",
                    "desc": "file",
                    "itemUrl": "",
                    "itemNcm":"itemNcm"
                }
            ],
            "invoiceNumber": "2332323",
            "invoiceSerialNumber": "32323",
            "invoiceMoney": "200",
            "taxCode": "2342424",
            "invoiceAccessKey": "12312323",
            "invoiceIssueDate": "2022-08-31 16:28:00",
            "packingNumber": "2312313",
            "documentNumber": "123123131",
            "documentSeries": "123123131",
            "documentKey": "345456234234",
            "documentCteKey": "345456234234"
        }
    ]
}`
             },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,


        //错误代码提示
        errcodeJson: [
          {code:'145003031',msg:`${this.$t('apiTestDoc.业务参数签名失败')}`},
        {code:'145003060',msg:`${this.$t('apiTestDoc.区域不合法')}`},
        {code:'145003061',msg:`${this.$t('apiTestDoc.城市不合法')}`},
        {code:'145003062',msg:`${this.$t('apiTestDoc.省份不合法')}`},
        {code:'145003064',msg:`${this.$t('apiTestDoc.查不到数据')}`},
        {code:'145003041',msg:`${this.$t('apiTestDoc.下单失败')}`},
        {code:'145003083',msg:`${this.$t('apiTestDoc.发件人信息不全')}`},
        {code:'145003084',msg:`${this.$t('apiTestDoc.收件人信息不全')}`},
        {code:'145003085',msg:`${this.$t('apiTestDoc.电话号码不能为空')}`},
        {code:'145003086',msg:`${this.$t('apiTestDoc.地址信息不全')}`},
        {code:'145003087',msg:`${this.$t('apiTestDoc.请检查订单类型、服务类型、派送类型、物品类型、快件类型、结算方式是否合法')}`},
        {code:'145003200',msg:`${this.$t('apiTestDoc.请检查服务类型是否合法值为 01或 02')}`},
        {code:'145003092',msg:`${this.$t('apiTestDoc.重量信息不合法')}`},
        {code:'145003093',msg:`${this.$t('apiTestDoc.物品信息不全')}`},
        {code:'145003094',msg:`${this.$t('apiTestDoc.物品名称不全')}`},
        {code:'145003095',msg:`${this.$t('apiTestDoc.物品类型不全')}`},
        {code:'145003101',msg:`${this.$t('apiTestDoc.客户订单号已存在,无法下单！')}`},
        {code:'145003103',msg:`${this.$t('apiTestDoc.姓名信息非法')}`},
        {code:'145003104',msg:`${this.$t('apiTestDoc.公司信息过长')}`},
        {code:'145003105',msg:`${this.$t('apiTestDoc.联系信息过长')}`},
        {code:'145003106',msg:`${this.$t('apiTestDoc.邮编或邮箱信息非法')}`},
        {code:'145003107',msg:`${this.$t('apiTestDoc.价格信息非法')}`},
        {code:'145003108',msg:`${this.$t('apiTestDoc.备注、描述、链接信息非法')}`},
        {code:'145003109',msg:`${this.$t('apiTestDoc.地址信息过长')}`},
        {code:'145003110',msg:`${this.$t('apiTestDoc.街道信息过长')}`},
        {code:'145003111',msg:`${this.$t('apiTestDoc.包裹总件数无效')}`},
        {code:'145003112',msg:`${this.$t('apiTestDoc.暂未开通代收货款业务')}`},
        {code:'145003113',msg:`${this.$t('apiTestDoc.支付方式不匹配,PP_CASH,CC_CASH,PP_MM')}`},
        {code:'145003201',msg:`${this.$t('apiTestDoc.已取件状态不可修改')}`},
        {code:'145003202',msg:`${this.$t('apiTestDoc.已取消状态不可修改')}`},
        {code:'145003203',msg:`${this.$t('apiTestDoc.更新订单失败，请稍后重试！')}`},
        {code:'145003083',msg:`${this.$t('apiTestDoc.始发地信息不全')}`},
        {code:'145003084',msg:`${this.$t('apiTestDoc.收货地信息不全')}`},
        {code:'145003085',msg:`${this.$t('apiTestDoc.发票信息不全')}`},
        {code:'145003086',msg:`${this.$t('apiTestDoc.发票信息不合法')}`},
        {code:'145003087',msg:`${this.$t('apiTestDoc.寄件人个人税号信息非法')}`},
        {code:'145003088',msg:`${this.$t('apiTestDoc.订单数量不同，无法修改订单')}`}]
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>
